export default "__VITE_ASSET__C_u5od22__"